import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { useQuery } from '@apollo/client/react'

import { NotFound } from 'js/core/NotFound'
import { onlyTypename } from 'js/lib/helpers/onlyTypename'
import { GET_ISSUE_ADD } from 'js/magazine-issue/AddEdit/Add/Add.queries'

import AddEditForm from '../AddEditForm/AddEditForm'

const Add = () => {
    const { t } = useTranslation()
    const { containerGuid } = useParams()

    const { data, loading } = useQuery(GET_ISSUE_ADD, {
        variables: {
            guid: containerGuid,
        },
    })

    if (loading) {
        return null
    }

    const entity = onlyTypename(data?.entity, 'Magazine')

    if (!entity?.canEdit) {
        return <NotFound />
    }

    return (
        <AddEditForm
            containerGuid={entity.guid}
            title={t('entity-magazine.create-issue')}
        />
    )
}

export default Add
